import React from 'react';

import './style.css';

/**
 * Блок "Отзывы".
 * @class
 * @param {Object} props         данные, пришедшие от родителя
 * @param {Object} props.reviews массив с данными отзывов
 * @memberof ArticlePage
 */
const Rev = (props) => (
  <div className="reviews-block">
    <h2 className="reviews__header">Реальные отзывы учеников</h2>
    <div className="review-block">
      <div className='flex-column'>
      {
        //используем вставку кода чтобы можно было форматировать inline внешний вид текста из админки (кроме цвета и размера текста)
        props.reviews.map((review, index) => (
          <div className="review" key={index}>
            <div className="review-content">
              <div className="review__img d-m-none" dangerouslySetInnerHTML={{ __html : review.image }} />
              <div className="author-text d-c-none" dangerouslySetInnerHTML={{ __html : review.text }} />
              <div className="review__text">
                <div className="review__img d-c-none" dangerouslySetInnerHTML={{ __html : review.image }} />
                <div className="author-name" dangerouslySetInnerHTML={{ __html : review.name }} />
                <div className="author-text d-m-none" dangerouslySetInnerHTML={{ __html : review.text }} />
              </div>
            </div>
            <div className="review-media">
              <div className="highlight" dangerouslySetInnerHTML={{ __html : review.highlight }} />
            </div>
          </div>
        ))
      }
      </div>

    </div>
  </div>
)

export default Rev;
